import PropTypes from "prop-types";
import { DropdownWrapper } from "components/global/Dropdown";
import chevronDown from "assets/icons/chevronDown.svg";
import Loader from "./Loader";
import { useClickOutside } from "webrix/hooks";
import Spacer from "./Spacer";
import PlatformPhoto from "./PlatformPhoto";
import ImgWrapper from "./ImgWrapper";
import { socialIcons } from "constants/post";
import userIcon from "assets/icons/userIconWhite.svg";

export const renderChannelComponent = (channel) => {
  return (
    <div className="flexRow alignCenter channel-wrapper">
      <PlatformPhoto key={channel?.platform}>
        <ImgWrapper
          // @ts-ignore
          size={3}
        >
          <img
            src={
              channel?.platform === "facebook"
                ? `https://graph.facebook.com/${channel?.page?.special_id}/picture?return_ssl_resources=true`
                : channel?.page?.photo || userIcon
            }
            alt="profile"
          />
        </ImgWrapper>
        <img
          src={socialIcons.circle[channel?.platform]}
          alt="text"
          width="12px"
          className="platformImg"
        />
      </PlatformPhoto>
      <Spacer x={1.0} />
      <p className="l3 ellipsify channel-name">{channel?.page?.name}</p>
    </div>
  );
};

/**
 * @param {Object} props
 * @param {string} props.value - value
 * @param {any} props.setValue - setter for value
 * @param {string} props.name - key
 * @param {string} [props.placeholder]
 * @param {string} [props.type]
 * @param {string} [props.label]
 * @param {Array} props.list
 * @param {string} [props.className]
 * @param {boolean} [props.readOnly]  -
 * @param {any} [props.renderContent]  -
 * @param {boolean} [props.required]  -
 * @param {any} [props.footer] -
 * @param {any} [props.onChange]  -
 * @param {any} [props.showClearState]
 */

const DropdownCustom = ({
  className,
  name,
  value,
  setValue = () => {},
  type,
  label,
  placeholder,
  list,
  readOnly,
  renderContent,
  required,
  footer,
  onChange = () => {},
  showClearState,
}) => {
  const toggleList = (open) => {
    if (readOnly) return;

    open
      ? document.querySelector(`#${name}`)?.classList.add("isOpen")
      : document.querySelector(`#${name}`)?.classList.remove("isOpen");
  };

  const handleSelect = (e, l) => {
    e.preventDefault();
    e.stopPropagation();
    setValue && setValue(l);
    toggleList(false);

    onChange(l);
  };

  const handleMouseDownCapture = useClickOutside(() => toggleList(false));

  if (renderContent) {
    return (
      <DropdownWrapper
        id={name}
        className={`dWrapper ${className ?? ""} ${!label ? "no-label" : ""}`}
        onMouseDownCapture={handleMouseDownCapture}
      >
        {label && (
          <label htmlFor={name} className="label">
            {label}
          </label>
        )}
        <div
          className="inputWrapper"
          onClick={() =>
            document.querySelector(`#${name}`).classList.toggle("isOpen")
          }
        >
          {value ? (
            renderContent(value)
          ) : (
            <p className="l3 colorBodyText">{placeholder}</p>
          )}
          <img src={chevronDown} alt="down" className="toggleIcon" />
        </div>
        <div className="list">
          {list?.map((item, index) => (
            <button
              type="button"
              onClick={(e) => handleSelect(e, item)}
              key={index}
              className="listItem"
            >
              {renderContent(item)}
            </button>
          ))}
          {footer && footer}
          {!list?.length && <Loader type="spinner" />}
        </div>
      </DropdownWrapper>
    );
  }

  return (
    <DropdownWrapper
      id={name}
      className={`dWrapper ${className ?? ""} ${!label ? "no-label" : ""}`}
      onMouseDownCapture={handleMouseDownCapture}
    >
      {label && (
        <label htmlFor={name} className="label">
          {label}
          {required && <span className="colorDanger label">*</span>}
        </label>
      )}
      <div
        className={`inputWrapper ${value && "hasValue"}`}
        onClick={() =>
          document.querySelector(`#${name}`).classList.toggle("isOpen")
        }
      >
        <input
          type={type || "text"}
          name={name}
          value={value || placeholder || "Select option"}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          placeholder={placeholder}
          className="selectInput"
          readOnly
        />
        <img src={chevronDown} alt="down" className="toggleIcon" />
      </div>

      <div className="list">
        {showClearState && (
          <div className="flexRow alignCenter justifyEnd clearState">
            <p
              className="cursorPointer l4 colorSecondary"
              onClick={() => {
                setValue(null);
                onChange(null);
                toggleList(false);
              }}
            >
              Clear
            </p>
          </div>
        )}
        {!!list?.length &&
          list?.map((item) => (
            <button
              key={item}
              type="button"
              className={`listItem l3 colorBodyText ${
                item === value && "active-item"
              }`}
              onClick={(e) => handleSelect(e, item?.toString())}
            >
              {item?.toLowerCase().replaceAll("_", " ")}
            </button>
          ))}
        {footer && footer}
        {!list?.length && <Loader />}
      </div>
    </DropdownWrapper>
  );
};

DropdownCustom.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.any,
  setValue: PropTypes.func,
  placeholder: PropTypes.string,
  list: PropTypes.array,
  hasIcon: PropTypes.bool,
  icon: PropTypes.any,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default DropdownCustom;
